import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input, Renderer2,
    ViewChild,
    ViewChildren
} from '@angular/core';

import {GenericField, IGenericField} from '../generic-field';
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";

/**
 * Text-field
 * Generate a simple text field
 * @extends GenericField
 * @deprecated Use TextComponent instead
 */
@Component({
    selector: 'text-field',
    templateUrl: './text-field.component.html',
    styleUrls: ['./text-field.component.scss'],
})
export class TextFieldComponent extends GenericField implements IGenericField, AfterViewInit {

    @Input()
    public id: string;

    @Input()
    public iconDef: IconDefinition;

    @Input()
    public focusFirst: EventEmitter<boolean> = new EventEmitter();

    @ViewChild('field')
    public field: ElementRef;

    constructor(private _renderer: Renderer2, private _elementRef: ElementRef){
        super();
    }


    public ngAfterViewInit(): void {
        if (this.focusOnMe) {
            this.onFocus({});
        }
        this._renderer.removeAttribute(this._elementRef.nativeElement, 'id')
    }

    public onFocus(event): void {
        super.onFocus(event);
        this.field.nativeElement.select();
    }
}
